import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { LogoutComponent } from './components/shared/commonComponents/logout/logout.component';
import { AccessDeniedComponent } from './components/shared/commonComponents/access-denied/access-denied.component';
import { PaymentprocessComponent } from './components/shared/paymentprocess/paymentprocess.component';
import { FeedbackSectionComponent } from './components/shared/feedback-section/feedback-section.component';
import { USER_TYPES } from './constant/constant';
import { InvalidLinkComponent } from './components/shared/commonComponents/invalid-link/invalid-link.component';
import { NotFoundPageComponent } from './components/shared/commonComponents/not-found-page/not-found-page.component';
import { SessionExpiredComponent } from './components/shared/commonComponents/session-expired/session-expired.component';
import { ENV } from '../environments/environment';

const userTypes = USER_TYPES;

export const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('./components/portal-home/portal-home.module').then(
                (module) => module.PortalHomeModule
            ),
    },
    {
        // USER_TYPES
        // path: 'patient',
        path: userTypes['PATIENT'],
        // component: PatientDashboardComponent
        loadChildren: () =>
            import('./components/patient/patient.module').then(
                (module) => module.PatientModule
            )
    },
    {
        // USER_TYPES
        // path: "doctor",
        path: userTypes['DOCTOR'],
        // component: DoctorDashboardComponent
        loadChildren: () =>
            import(
                './components/medical-profession/doctors/doctors.module'
            ).then((module) => module.DoctorsModule)
    },
    {
        // USER_TYPES
        // path: "other-medical-professionals",
        path: userTypes['OTHER-MEDICAL-PROFESSIONALS'],
        // component: DoctorDashboardComponent
        loadChildren: () =>
            import(
                './components/medical-profession/other-medical-profession/other-medical-profession.module'
            ).then((module) => module.OtherMedicalProfessionModule)
    },
    {
        // USER_TYPES
        // path: "other-medical-professionals",
        path: userTypes['SUPPORT'],
        // component: DoctorDashboardComponent
        loadChildren: () =>
            import(
                './components/medical-profession/support/support.module'
            ).then((module) => module.SupportModule)
    },
    {
        // USER_TYPES
        // path: "other-medical-professionals",
        path: userTypes['VENDOR'],
        // component: DoctorDashboardComponent
        loadChildren: () =>
            import(
                './components/medical-profession/vendor/vendor.module'
            ).then((module) => module.VendorModule)
    },
    { path: 'paymentprocess', component: PaymentprocessComponent },
    { path: ':slug/logout', component: LogoutComponent },
    { path: 'invalidlink', component: InvalidLinkComponent },
    { path: 'accessdenied', component: AccessDeniedComponent },
    { path: 'notfound', component: NotFoundPageComponent },
    { path: 'sessionexpired', component: SessionExpiredComponent },

    // {
    //     path: 'referral/registration/other-medical-professionals/:token',
    //     component: MedicalProffessionalRegistrationComponent
    // },
    { path: 'covid19_feedback', component: FeedbackSectionComponent },
    { path: 'feedback/:source', component: FeedbackSectionComponent },
    { path: '**', component: NotFoundPageComponent }
];

export const AppRoutes = RouterModule.forRoot(routes, {
    useHash: false, 
    scrollPositionRestoration: 'enabled',
    enableTracing: ENV.tracing
});
